import React from 'react';

import {
  Popover,
  Popconfirm,
  Button,
  Icon,
  Input
} from "antd";

class ActionsButtons extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      popoverVisible: false,
      value: this.props.data.title
    }
  }

  render() {
    return (
      <div style={{
        display: 'flex',
        flexWrap: 'nowrap'
      }}>
        <Popconfirm
          title="Are you sure?"
          onConfirm={() => this.props.onListButtonDelete(this.props.data._id)}
        >
          <Button
            size="small"
            type="danger">
            <Icon type="delete" />
          </Button>
        </Popconfirm>

        <Popover
          content={
            <div>
              <Input
                value={this.state.value}
                onChange={(e) => this.setState({ value: e.target.value })}/>
              <Button 
                size="small"
                onClick={() => this.onListButtonEdit()}>OK</Button>
            </div>
          }
          title="Click title"
          trigger="click"
          visible={this.state.popoverVisible}
          onVisibleChange={() => this.setState({ popoverVisible: !this.state.popoverVisible })}
        >
          <Button 
            type="primary"
            size="small">
            <Icon type="edit"/>  
          </Button>
        </Popover>
      </div>
    );
  }

  onListButtonEdit = () => {

    const id = this.props.data._id
    const value = this.state.value

    this.setState({ popoverVisible: false})

    this.props.onListButtonEdit(id, value);
  }

}

export default ActionsButtons;


// WEBPACK FOOTER //
// ./src/components/three-ps/actions-buttons.js